import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import Login from '../components/authentication/Login';

const ProtectedRoute = ({ element }) => {
  const { isAuthenticated } = useContext(AppContext);
  const [isLoginOpen, setLoginOpen] = useState(true);
  const [loginClosed, setLoginClosed] = useState(false); // new flag

  const location = useLocation();
  const navigate = useNavigate();

  const closeLogin = () => {
    setLoginOpen(false);
    setLoginClosed(true); // mark that login was closed
  };

  // If user closes login and is still unauthenticated, navigate back
  useEffect(() => {
    if (loginClosed && !isAuthenticated) {
      navigate(-1);
    }
  }, [loginClosed, isAuthenticated, navigate]);

  if (isAuthenticated) return element;

  return <Login isOpen={isLoginOpen} onClose={closeLogin} />;
};

export default ProtectedRoute;
